'use strict';

define('dropdown-language',['jquery'], function ($) {

  var
    $dropdownButton             = $('#js-dropdown-button'),
    $dropdownContent            = $('#js-dropdown-content'),
    is_Open                     = false,
    Open_Class                  = 'is-menu-opened';

  var attachEvents = function() {
    $dropdownButton.on('click', function() {
      changeShowDropdown();
    });
  };

  var changeShowDropdown = function() {
    is_Open = !is_Open;

    if (is_Open === true)
      $dropdownContent.addClass(Open_Class);
    else
      $dropdownContent.removeClass(Open_Class);
  };

  $(function() {
    attachEvents();
  });
});
